import { Injectable, Inject } from '@angular/core';
import { ToastController } from 'ionic-angular';

@Injectable()
export class CustomToastComponent {

  public toast: any;

  constructor(private toastCtrl: ToastController) {}

  show(message: string, duration: number, position: string){
    this.toast = this.toastCtrl.create({
     message: message,
     duration: duration,
     position: position
   });

   this.toast.present();
  }

  showComplete(message: string, duration: number, position: string, showCloseButton: boolean, closeButtonText: string, dismissOnPageChange: boolean){
    let toast = this.toastCtrl.create({
     message: message,
     duration: duration,
     position: position,
     showCloseButton: showCloseButton,
     closeButtonText: closeButtonText,
     dismissOnPageChange: dismissOnPageChange
   });

   this.toast.present();
  }

  hide(){
     this.toast.onDidDismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/custom-toast/custom-toast.ts